import React, { useMemo } from 'react'
import { SaveIcon } from 'stylist'

const CSVLink = ({ headers = [], tableData = [], children, ...props }) => {
  // https://www.delftstack.com/howto/javascript/export-javascript-csv/
  const csv = useMemo(
    () =>
      [headers, ...tableData]
        .map(JSON.stringify)
        .join('\r\n')
        .replace(/(^\[)|(\]$)/gm, ''),
    [headers, tableData]
  )
  const encodedUri = useMemo(
    () => encodeURI(`data:text/csv;charset=utf-8,${csv}`),
    [csv]
  )

  return (
    <a {...props} href={encodedUri}>
      <SaveIcon /> {children}
    </a>
  )
}

export default CSVLink



// WEBPACK FOOTER //
// ./src/routes/admin/CSVLink.js